// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ReportSection-base__OyOA_{display:flex;flex-direction:column;gap:var(--size-3)}.ReportSection-chartGrid__d58Z_{display:grid;grid-template-columns:repeat(auto-fill, minmax(min(400px, 100%), 1fr));grid-gap:var(--size-4);gap:var(--size-4);align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "ReportSection-base__OyOA_",
	"chartGrid": "ReportSection-chartGrid__d58Z_"
};
export default ___CSS_LOADER_EXPORT___;
